module.exports = __webpack_public_path__ + "img/mobile_banner.06b980c2.png";